import * as z from "zod/v4";

export const refreshPrintNodeIntegration = {
  name: "refreshPrintNodeIntegration" as const,
  input: z.object({}),
  output: z.void(),
};
